import { render } from "./UniqueCallsToggle.vue?vue&type=template&id=130f4da8&scoped=true"
import script from "./UniqueCallsToggle.vue?vue&type=script&lang=js"
export * from "./UniqueCallsToggle.vue?vue&type=script&lang=js"

import "./UniqueCallsToggle.vue?vue&type=style&index=0&id=130f4da8&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130f4da8"]])

export default __exports__